import Salefunnel from '@/pages/salestatus/salefunnel'

export default [
  {
    path: '/salefunnel',
    name: 'Salefunnel',
    component: Salefunnel,
    meta: { name: '销售漏斗' }
  }
]



// WEBPACK FOOTER //
// ./src/router/salestatus/salefunnel.js